import { Hexagon } from 'lucide-react';

export default function EmptyState({ title, text }) {
  return (
    <div className="state-panel">
      <div className="empty-hex" aria-hidden="true">
        <Hexagon size={34} strokeWidth={1.6} />
      </div>
      <h2>{title}</h2>
      {text ? <p>{text}</p> : null}
    </div>
  );
}
